import Environment from '../../Environment';

interface CloudAppsLinkProps {
  relativeUrl: string | undefined | null;
  label: string | number | undefined | null;
}

function CloudAppsLink({ relativeUrl, label }: CloudAppsLinkProps) {
  return (
    <a href={`${Environment.CLOUDAPPS_URL()}${relativeUrl}`} target="_blank" rel="noreferrer">
      {label}
    </a>
  );
}

export default CloudAppsLink;
